import React from 'react';
import { FuelGridContainer, FuelGridItem } from '@frete.com/fuel-react';
import FieldCity from '../FieldCity';
import FieldDate from '../FieldDate';
import { FieldAddressPropsInterface } from './FieldAddressTypes';

function FieldAddress({ flow }: FieldAddressPropsInterface) {
  return (
    <FuelGridContainer gapRow={24} style={{ margin: 0 }}>
      <FuelGridItem sm={2} md={4} lg={7} xlg={7}>
        <FieldCity flow={flow} />
      </FuelGridItem>
      <FuelGridItem sm={2} md={4} lg={5} xlg={5}>
        <FieldDate flow={flow} />
      </FuelGridItem>
    </FuelGridContainer>
  );
}

export default FieldAddress;
